import { render, staticRenderFns } from "./starbucks.vue?vue&type=template&id=3e525f1c"
import script from "./starbucks.vue?vue&type=script&lang=js"
export * from "./starbucks.vue?vue&type=script&lang=js"
import style0 from "./starbucks.vue?vue&type=style&index=0&id=3e525f1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports